import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardBody,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  FormFeedback,
  Form,
  Col,
  Row,
  Collapse,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import "../../../assets/scss/custom/components/timeline.scss";
import { useFormik } from "formik";
import * as Yup from "yup";
import classnames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src";
import {
  addObjectives,
  deleteObjectives,
  getObjectivesByProject,
} from "src/slices/objectives/thunk";
import useToast from "src/components/Common/toast";
import "../../../assets/scss/type-number.scss";
import {
  addStatusPoints,
  deleteStatusPoints,
  updateStatusPoints,
} from "src/slices/thunks";
import getMonthName from "src/helpers/get_month";
import { formatDate } from "src/common/date-formater";
import { CSVLink, CSVDownload } from "react-csv";
/*import axios from "axios";
import { API_URL } from "src/utils/apiConfig";*/
import DatePicker from  'react-datepicker';

function getYYYYMM(date : Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
  return `${year}${month}`;
}

const Objectives = ({ project }: any) => {
  const [successDelete, setSuccessDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState(false);
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [errorUpdate, setErrorUpdate] = useState(false);
  const { show, ToastComponent } = useToast();
  const [quantidadeExecutada, setQuantidadeExecutada] = useState<number>(0);
  const [nivelExecucao, setNivelExecucao] = useState<number>(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const [modal_center, setmodal_center] = useState(false);
  const [modal_objectivo, setmodal_objectivo] = useState(false);
  const objectives = useSelector((state: any) => state.objectives.objectives);
  const statusPoints = useSelector((state: any) => state.statusPoints.statusPoints);
  const dispatch = useDispatch<AppDispatch>();
  const [modal, setModal] = useState<boolean>(false);
  const [currentMonth, setMes] = useState(new Date());
  const [openAccordion, setOpenAccordion] = useState<number>(0);
  const [objectiveState, setObjectiveState] = useState<any>();
  const [statusState, setStatusState] = useState<any>();
  const [updateStatus, setUpdateStatus] = useState<boolean>(false);

  useEffect(() => {
    if (errorDelete) {
      show("Erro", "Erro ao apagar o objectivo.");
      setErrorDelete(false);
    } else if (successDelete) {
      show("Sucesso", "Objectivo apagado com sucesso.");
      setSuccessDelete(false);
    } else if (errorUpdate) {
      show("Erro", "Erro ao actualizar o objectivo.");
      setErrorUpdate(false);
    } else if (successUpdate) {
      show("Sucesso", "Objectivo actualizado com sucesso.");
      setSuccessUpdate(false);
    }
  }, [successDelete, errorDelete, successUpdate, errorUpdate]);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [statusPoints]);

  function tog_objectivo() {
    setmodal_objectivo(!modal_objectivo);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: updateStatus ? {
          mes: statusState.mes,
          semana: statusState.semana,
          quantidade_executada: statusState.quantidade,
          observacao: statusState.observacao,
          nivel_execucao: statusState.nivel_execucao,
        } : {
          mes: getYYYYMM(currentMonth),
          semana: "4",
          quantidade_executada: "",
          observacao: "",
          nivel_execucao: 0,
        },
    validationSchema: Yup.object({
      mes: Yup.string().required("Por favor, insira o mês"),
      semana: Yup.string().required("Por favor, insira a semana"),
      quantidade_executada: Yup.number().required("Por favor, insira a quantidade executada"),
      observacao: Yup.string().optional(),
      nivel_execucao: Yup.number().required("Por favor, insira o nível de execução"),
    }),
    onSubmit: async values => {
      if (updateStatus) {
        dispatch(
          updateStatusPoints({
            ...values,
            nivel_execucao: nivelExecucao,
            id: statusState.id,
          })
        ).then(() => {
          dispatch(getObjectivesByProject(project.id));
        });
      } else {
        dispatch(
          addStatusPoints({
            ...values,
            objective_id: objectiveState.id,
            nivel_execucao: nivelExecucao,
          })
        ).then(() => {
          dispatch(getObjectivesByProject(project.id));
        });
      }

      setmodal_center(false);
      setUpdateStatus(false);
      setNivelExecucao(0);
      validation.resetForm();
    },
  });

  const objectivoValidation = useFormik({
    initialValues: {
      quantidade_prevista: "",
      unidade: "",
    },
    validationSchema: Yup.object({
      quantidade_prevista: Yup.string().required("Por favor, insira a quantidade prevista"),
      unidade: Yup.string().required("Por favor, insira a unidade"),
    }),
    onSubmit: async values => {
      dispatch(addObjectives({ ...values, project_id: project.id })).then(
        () => {
          setOpenAccordion(objectives.length);
        }
      );
      setmodal_objectivo(false);
      objectivoValidation.resetForm();
    },
  });

  const toggleAccordion = (index: number) => {
    setOpenAccordion(index);
  };

  const toggle = () => {
    setModal(!modal);
  };

  const handleDelete = (objective_id: number) => {
    dispatch(deleteObjectives(objective_id)).then(response => {
      setModal(false);
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        setErrorDelete(true);
      } else {
        setSuccessDelete(true);
        dispatch(getObjectivesByProject(project.id));
      }
    });
  };

  const handleRowClick = (objective: any) => {
    setObjectiveState(objective);
    toggle();
  };

  const tog_center = (objective: any) => {
    setmodal_center(!modal_center);
    setObjectiveState(objective);
  };
  useEffect(() => {
    if (objectiveState) {
      const totalQuantity = objectiveState.quantidade;
      const percentage = (quantidadeExecutada / totalQuantity) * 100;
      setNivelExecucao(parseFloat(percentage.toFixed(2)));
    }
  }, [quantidadeExecutada]);

  const handleStatusClick = (status: any) => {
    setmodal_center(!modal_center);
    setUpdateStatus(true);
    setStatusState(status);
    setNivelExecucao(status.nivel_execucao);
  };

  const handleDeleteStatus = (id: number) => {
    dispatch(deleteStatusPoints(id)).then(response => {
      if (
        typeof response.payload === "string" &&
        (response.payload.includes("Request failed with") || response.payload.includes("Internal Server Error"))
      ) {
        show("Erro", "Erro ao apagar o ponto de situação.");
      } else {
        dispatch(getObjectivesByProject(project.id));
      }
    });
    setmodal_center(false);
    setUpdateStatus(false);
    setStatusState(null);
    setNivelExecucao(0);
  };

  return (
    <React.Fragment>
      {ToastComponent}
      <Card>
        <CardBody>
          <div className="d-flex align-items-start mb-2">
            <div className="flex-grow-1">
              <h5 className="card-title">Quantificação</h5>
            </div>
            {/*<div className="d-flex flex-shrink-0 gap-2">
              <Button className="btn btn-light" onClick={() => tog_objectivo()}>
                Adicionar Objectivo
              </Button>
            </div>*/}
          </div>
          {/*<Modal isOpen={modal} toggle={toggle} centered={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Apagar Objectivo
            </ModalHeader>
            <ModalBody>
              <p>
                Apagar este objectivo irá remover todos os pontos de situação
                associados a este objectivo.
              </p>
              <div className="d-flex flex-wrap gap-2 justify-content-end">
                <Button
                  type="button"
                  color="danger"
                  onClick={() => handleDelete(objectiveState.id)}
                >
                  Apagar
                </Button>
              </div>
            </ModalBody>
          </Modal>*/}
          <SimpleBar style={{ maxHeight: "500px" }} scrollableNodeProps={{ ref: containerRef }}>
            {objectives.length > 0 ? (
              <>
                {objectives &&
                  Array.isArray(objectives) &&
                  objectives.map((objective: any, index: number) => (
                    <div style={{marginRight: "16px",}} key={objective.id}>
                      <div className="accordion-item">
                        <div className="d-flex justify-content-between">
                          <h2
                            className="accordion-header"
                            id={`flush-heading${index}`}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <button
                              className={classnames(
                                "accordion-button",
                                "fw-medium",{
                                  collapsed: openAccordion !== index,
                                }
                              )}
                              type="button"
                              onClick={() => toggleAccordion(index)}
                              style={{ cursor: "pointer" }}
                            >
                              Unidade: {objective.unidade}, Quantidade:{" "}
                              {objective.quantidade}
                            </button>
                          </h2>
                          {openAccordion === index && (
                            <div style={{ cursor: "pointer" }} onClick={() => handleRowClick(objective)}>
                              <i className="uil uil-times text-muted"></i>
                            </div>
                          )}
                        </div>

                        <Collapse isOpen={openAccordion === index} className="accordion-collapse">
                          {objective.situacoes.map(
                            (status: any, statusIndex: number) => (
                              <div key={statusIndex} className="tl-item">
                                <div className="tl-dot b-primary"></div>
                                <div
                                  className="tl-content"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleStatusClick(status)}
                                >
                                  <div className="tl-date text-muted mt-1">
                                    {getMonthName(parseInt(status.mes))}
                                  </div>
                                  <div className="">
                                    Quantidade Executada: {status.quantidade}{" "}
                                    {objective.unidade}, Nível de Execução:{" "}
                                    {status.nivel_execucao}%
                                  </div>
                                  <div>
                                    <p
                                      className="text-muted"
                                      style={{
                                        overflow: "hidden",
                                        display: "-webkit-box",
                                        WebkitBoxOrient: "vertical",
                                        WebkitLineClamp: 2,
                                      }}
                                    >
                                      {status.observacao}
                                    </p>
                                  </div>
                                  {/*<div className="tl-date text-muted mt-1">
                                    Criado em {formatDate(status.create_date)}
                                  </div>*/}
                                </div>
                              </div>
                            )
                          )}
                          {objective.situacoes.length === 0 ? (
                            <div className="text-muted mt-2">
                              Não há pontos de situação,{" "}
                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "#007bffe6",
                                  textDecoration: "underline",
                                }}
                                onClick={() => tog_center(objective)}
                              >
                                Adicionar ponto de situação
                              </span>                              
                            </div>
                          ) : (
                            <div className="tl-dot-special" onClick={() => tog_center(objective)}>
                              <i className="uil uil-plus"></i>
                            </div>
                          )}
                          <div className="tl-content"></div>
                        </Collapse>
                      </div>
                      {index < objectives.length - 1 && <hr />}
                    </div>
                  ))}
              </>
            ) : (
              <div className="text-muted">Esta actividade não possui quantidades.</div>
            )}
          </SimpleBar>
          <Modal
            isOpen={modal_center}
            toggle={() => {
              setmodal_center(!modal_center);
              setUpdateStatus(false);
            }}
            centered={true}
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0">{updateStatus ? "Actualizar" : "Adicionar"} Ponto de Situação</h5>
              <button
                type="button"
                onClick={() => {setmodal_center(false);}}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={validation.handleSubmit}>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="mes">Mês</Label>
                      <DatePicker                        
                        selected={currentMonth}
                        showMonthYearPicker
                        dateFormat="MM/yyyy"
                        onChange={(date: React.SetStateAction<Date>) => setMes(date)}                        
                        showIcon
                      />
                      {validation.touched.mes && validation.errors.mes ? (
                        <FormFeedback type="invalid">{String(validation.errors.mes)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="semana">Semana</Label>
                      <Input
                        type="select"
                        className="form-control"
                        placeholder="Insira a semana"
                        id="semana"
                        name="semana"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.semana}
                        invalid={validation.touched.semana && validation.errors.semana ? true : false}
                      >
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                      </Input>
                      {validation.touched.semana && validation.errors.semana ? (
                        <FormFeedback type="invalid">{String(validation.errors.semana)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="quantidade_executada">Quantidade Executada</Label>
                      <Input
                        type="number"
                        className="form-control"
                        placeholder="Insira a quantidade executada"
                        id="quantidade_executada"
                        name="quantidade_executada"
                        onChange={e => {
                          validation.handleChange(e);
                          setQuantidadeExecutada(Number(e.target.value));
                        }}
                        onBlur={validation.handleBlur}
                        value={validation.values.quantidade_executada}
                        invalid={
                          validation.touched.quantidade_executada &&
                          validation.errors.quantidade_executada ? true: false
                        }
                      />
                      {validation.touched.quantidade_executada ? (
                        <FormFeedback type="invalid">{String(validation.errors.quantidade_executada)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup className="mb-3">
                      <Label htmlFor="nivel_execucao">Nível de Execução (%)</Label>
                      <Input
                        type="number"
                        className="form-control"
                        placeholder="Insira o nível de execução"
                        id="nivel_execucao"
                        name="nivel_execucao"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={nivelExecucao.toFixed(2)}
                        invalid={
                          validation.touched.nivel_execucao &&
                          validation.errors.nivel_execucao ? true : false
                        }
                      />
                      {validation.touched.nivel_execucao &&
                      validation.errors.nivel_execucao ? (
                        <FormFeedback type="invalid">{String(validation.errors.nivel_execucao)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <FormGroup className="mb-3">
                  <Label htmlFor="observacao">Observação</Label>
                  <Input
                    type="textarea"
                    className="form-control"
                    placeholder="Insira a observação"
                    id="observacao"
                    name="observacao"
                    style={{ height: "130px" }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.observacao}
                    invalid={
                      validation.touched.observacao &&
                      validation.errors.observacao ? true : false
                    }
                  />
                  {validation.touched.observacao &&
                  validation.errors.observacao ? (
                    <FormFeedback type="invalid">{String(validation.errors.observacao)}</FormFeedback>
                  ) : null}
                </FormGroup>

                <div className="d-flex justify-content-end gap-2">
                  {updateStatus ? (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleDeleteStatus(statusState.id)}
                    >
                      Apagar
                    </button>
                  ) : (
                    <button type="button" className="btn btn-secondary" onClick={() => {setmodal_center(false);}}>
                      Cancelar
                    </button>
                  )}
                  <button type="submit" className="btn btn-primary">Salvar</button>
                </div>
              </Form>
            </div>
          </Modal>
          <Modal isOpen={modal_objectivo} toggle={() => {tog_objectivo();}} centered={true}>
            <div className="modal-header">
              <h5 className="modal-title mt-0">Adicionar Objectivo</h5>
              <button
                type="button"
                onClick={() => {setmodal_objectivo(false);}}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form onSubmit={objectivoValidation.handleSubmit}>
                <Row>
                  <Col>
                    <FormGroup className="mb-3">
                      <Label htmlFor="quantidade_prevista">Quantidade Prevista</Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Insira a quantidade prevista"
                        id="quantidade_prevista"
                        name="quantidade_prevista"
                        onChange={objectivoValidation.handleChange}
                        onBlur={objectivoValidation.handleBlur}
                        value={objectivoValidation.values.quantidade_prevista}
                        invalid={
                          objectivoValidation.touched.quantidade_prevista &&
                          objectivoValidation.errors.quantidade_prevista ? true : false
                        }
                      />
                      {objectivoValidation.touched.quantidade_prevista &&
                      objectivoValidation.errors.quantidade_prevista ? (
                        <FormFeedback type="invalid">{String(objectivoValidation.errors.quantidade_prevista)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                  <Col lg="5">
                    <FormGroup className="mb-3">
                      <Label htmlFor="unidade">Unidade</Label>
                      <Input
                        type="select"
                        className="form-control"
                        id="unidade"
                        name="unidade"
                        onChange={objectivoValidation.handleChange}
                        onBlur={objectivoValidation.handleBlur}
                        value={objectivoValidation.values.unidade}
                        invalid={
                          objectivoValidation.touched.unidade &&
                          objectivoValidation.errors.unidade ? true : false
                        }
                      >
                        <option value="">Selecione a unidade</option>
                        <option value="ha">ha</option>
                        <option value="Km">Km</option>
                        <option value="Lote">Lote</option>     
                        <option value="m">m</option>
                        <option value="m2">m2</option>
                        <option value="m3">m3</option>
                        <option value="mL">mL</option>
                        <option value="Percentagem">Percentagem</option>
                        <option value="Pessoas">Pessoas</option>
                        <option value="UN">UN</option>
                        <option value="VG">VG</option>
                      </Input>
                      {objectivoValidation.touched.unidade &&
                      objectivoValidation.errors.unidade ? (
                        <FormFeedback type="invalid">{String(objectivoValidation.errors.unidade)}</FormFeedback>
                      ) : null}
                    </FormGroup>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end gap-2">
                  <button type="button" className="btn btn-secondary" onClick={() => {setmodal_objectivo(false);}}>
                    Cancelar
                  </button>
                  <button type="submit" className="btn btn-primary">Salvar</button>
                </div>
              </Form>
            </div>
          </Modal>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Objectives;
